/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getSchoolAverageBySeason = function (seasonId,eventId,teamId) 
{
    const endpoint = `/${seasonId}/${eventId}/${teamId}/schoolAverage`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
}


// WEBPACK FOOTER //
// ./src/components/pages/api/getSchoolAverageBySeason.js